require('@core/bootstrap');
require('./components');
require('./mixins');
require('@core/services');

import Vue from 'vue';
import vuetify from './plugins/vuetify';
import vuemeta from './plugins/vuemeta';
import store from '@store';

new Vue({
    vuetify,
    store,
    el: '#app',
    metaInfo: vuemeta
});
